import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";


const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

export const Container = styled('div')(({theme}) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    width: '850px'
  },
  [theme.breakpoints.up('lg')]: {
    width: '1200px'
  },
  [theme.breakpoints.down('md')]: {
    width: '90vw'
  },
}))

export const Header = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.detailTextColor,
    width: '100%',
    height: 'fit-content',
    borderRadius:'10px 10px 0 0',
    padding:'16px',
    textTransform:'uppercase',
    fontWeight:600,
    [desktop]: {
      fontSize:'0.95rem',
    }
  }
})

export const Body = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    flexDirection:'column',
    flex:'1',
    width: '100%',
    background: colors.white,
  }
})

export const Footer = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius:'0 0 10px 10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '8px 16px',
    margin: 'auto'
  }
})

export const ContainerButtonCreate = styled('div')(() => ({
	width: 170,
	height: 40,
	[desktop]: {
		width: "120px",
		height: "30px",
		"& button": {
			padding: "14px 12px",
			fontSize: "0.55rem",
		},
	},
	[tablet]: {
		width: "110px",
		height: 20,
		"& button": {
			fontSize: "7px",
		},
	},
}))

function buttonType(type) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { colors } = useColors();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'cancel') return colors.white
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'close') return colors.white
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'delete') return colors.red
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return colors.buttonActionColor
}

export const DownloadButton = styled(Button)(({type}) => {
    const { colors } = useColors();
    return {
        height: 30,
        width: '100%',
        padding: "0 20px",
        background: buttonType(type),
        color: `${type !== 'cancel' && type !== 'close' ? colors.white : colors.buttonActionColor}`,
        borderColor: colors.buttonActionColor,
        "&:hover": {
            background: buttonType(type),
            borderColor: colors.buttonActionColor,
            opacity: 0.9
        }
    }
})
